import React from 'react';
import EmojiFoodBeverageRoundedIcon from '@material-ui/icons/EmojiFoodBeverageRounded';

import GenericDetail
  from 'gui/components/listPage/components/ad/components/genericDetail';
import {mealTypes} from 'gui/components/editors/hotelEditor/components/hotelDetailsForm/components/offerDetails/components/roomMealSelector';
import {IProduct} from 'data/interfaces/products';


interface IAdMealType {
  product: Partial<IProduct>;
}

export const generateMealText = product => {
  if (product.hotelDetails) {
    const meal = mealTypes.find((mealType) => mealType.value === Math.max(Math.min(product.hotelDetails.roomMeal, mealTypes.length - 1), 0));
    if (meal)
      return meal.label;
  }
  return 'אין'
};

const AdMealType = (props: IAdMealType) => (
  <GenericDetail
    title="סוג ארוחה"
    icon={EmojiFoodBeverageRoundedIcon}
  >
    {generateMealText(props.product)}
  </GenericDetail>
);

AdMealType.defaultProps = {
  roomMeal: 0,
};
export default AdMealType;
